import { ApolloCache, Reference } from "@apollo/client"
import { SEGMENTATION_FRAGMENT } from "../fragment/segmentation"

export const updateCacheSegmentation = ({
  cache,
  entryData,
  action,
}: {
  cache: ApolloCache<any>
  entryData: any
  action: "update" | "delete" | "add"
}) => {
  return cache.modify({
    fields: {
      segmentations(existing = []) {
        const newSegmentationRef = cache.writeFragment({
          data: entryData,
          fragment: SEGMENTATION_FRAGMENT,
        })
        switch (action) {
          case "add":
            return [...existing, newSegmentationRef]
          case "delete":
            return [
              ...existing?.filter(
                (el: Reference | undefined) =>
                  el?.__ref !== newSegmentationRef?.__ref,
              ),
            ]
          case "update":
            const index = existing.findIndex(
              (el: Reference | undefined) =>
                el?.__ref !== newSegmentationRef?.__ref,
            )
            const items = [...existing]
            if (index > -1) {
              items[index] = newSegmentationRef
            }
            return items
        }
      },
      aggregateSegmentation(existing = {}) {
        let _all = existing?._count?._all
        switch (action) {
          case "add":
            return {
              ...existing,
              _count: {
                ...existing?._count,
                _all: _all ? _all + 1 : 0,
              },
            }
          case "delete":
            return {
              ...existing,
              _count: {
                ...existing?._count,
                _all: _all ? _all - 1 : 0,
              },
            }
        }
      },
    },
  })
}
